import { takeEvery, put } from 'redux-saga/effects';

import { TRANSCLUSION_FROM_NEW_PASSWORD, transclusionShow } from 'src/app/redux/actions/transclusion';
import apiErrorSaga from 'src/app/redux/sagas/apiErrorSaga.json';
import transclusionSaga from 'src/app/redux/sagas/transclusionSaga.json';


function* parseErrorsToTransclusion({ payload }) {
  const { errors } = payload;
  const { invalidResetToken } = apiErrorSaga;
  const { resetPasswordInvalidToken, resetPasswordError } = transclusionSaga;

  const containsTokenError = errors
    .some(({ statusCode }) => statusCode === invalidResetToken);

  yield put(transclusionShow(containsTokenError ? resetPasswordInvalidToken : resetPasswordError));
}

export default [
  takeEvery(TRANSCLUSION_FROM_NEW_PASSWORD, parseErrorsToTransclusion)
];
